import React from "react";
// Styles
import useStyles from "assets/jss/material-react/views/italmundoStyles";
import { useTheme } from "@mui/material/styles";
// Components
import { Grid, useMediaQuery, FormControl, TextField } from "@mui/material";

const LETTER_SPACE_REGEX = /^[a-zA-Z\s]+$/;
const onlyLettersKeyDown = (event) => {
  if (
    !LETTER_SPACE_REGEX.test(event.key) &&
    event.key !== "Backspace" &&
    event.key !== "Tab"
  ) {
    event.preventDefault();
  }
};

export const PrimerNombre = ({ handleChange, values, errors, errorMessages }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.primerNombre}
        className={classes.formControlCustom}
      >
        <TextField
          id="primer-nombre"
          label="Primer Nombre*"
          variant="filled"
          name="primerNombre"
          onKeyDown={onlyLettersKeyDown}
          value={values.primerNombre}
          onChange={handleChange}
          className={classes.inputCustom}
          error={!!errors.primerNombre}
          helperText={errorMessages.primerNombre}
          inputProps={{ autoComplete: "given-name" }}
        />
      </FormControl>
    </Grid>
  );
};

export const SegundoNombre = ({ handleChange, values, errors, errorMessages }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.segundoNombre}
        className={classes.formControlCustom}
      >
        <TextField
          id="segundo-nombre"
          label="Segundo Nombre"
          variant="filled"
          name="segundoNombre"
          onKeyDown={onlyLettersKeyDown}
          value={values.segundoNombre}
          onChange={handleChange}
          className={classes.inputCustom}
          error={!!errors.segundoNombre}
          helperText={errorMessages.segundoNombre}
          inputProps={{ autoComplete: "additional-name" }}
        />
      </FormControl>
    </Grid>
  );
};

export const PrimerApellido = ({ handleChange, values, errors, errorMessages }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.primerApellido}
        className={classes.formControlCustom}
      >
        <TextField
          id="primer-apellido"
          label="Primer Apellido*"
          variant="filled"
          name="primerApellido"
          onKeyDown={onlyLettersKeyDown}
          value={values.primerApellido}
          onChange={handleChange}
          className={classes.inputCustom}
          error={!!errors.primerApellido}
          helperText={errorMessages.primerApellido}
          inputProps={{ autoComplete: "family-name" }}
        />
      </FormControl>
    </Grid>
  );
};

export const SegundoApellido = ({ handleChange, values, errors, errorMessages }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.segundoApellido}
        className={classes.formControlCustom}
      >
        <TextField
          id="segundo-apellido"
          label="Segundo Apellido"
          variant="filled"
          name="segundoApellido"
          onKeyDown={onlyLettersKeyDown}
          value={values.segundoApellido}
          onChange={handleChange}
          className={classes.inputCustom}
          error={!!errors.segundoApellido}
          helperText={errorMessages.segundoApellido}
          inputProps={{ autoComplete: "family-name" }}
        />
      </FormControl>
    </Grid>
  );
};

export const Email = ({ handleChange, values, errors, errorMessages }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.email}
        className={classes.formControlCustom}
      >
        <TextField
          id="filled-required"
          label="Correo electrónico*"
          variant="filled"
          name="email"
          value={values.email}
          onChange={handleChange}
          error={errors.email}
          className={classes.inputCustom}
          helperText={errorMessages.email}
          inputProps={{ autoComplete: "email" }}
        />
      </FormControl>
    </Grid>
  );
};

export const Celular = ({ handleChange, values, errors, errorMessages }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.celular}
        className={classes.formControlCustom}
      >
        <TextField
          id="filled-required"
          label="Celular*"
          variant="filled"
          name="celular"
          inputProps={{ autoComplete: "tel" }}
          className={classes.inputCustom}
          value={values.celular}
          onChange={handleChange}
          error={errors.celular}
          onInput={(e) => {
            if (e.target.value !== "") {
              // Convertir el valor a entero y luego a cadena
              let parsedValue = parseInt(e.target.value).toString();
              if (isNaN(parsedValue)) {
                e.target.value = "";
              } else {
                // Verificar si el valor original comienza con "0"
                if (e.target.value.startsWith("0")) {
                  // Si comienza con "0", mantenerlo como está
                  e.target.value = e.target.value.slice(0, 9);
                } else {
                  // Si no comienza con "0", aplicar la lógica original
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 9);
                }
              }
            }
          }}
          helperText={errorMessages.celular}
        />
        <p className={classes.textoDescriptivo}>
          Debe contener <span className="special-font">9</span> caracteres.
        </p>
      </FormControl>
    </Grid>
  );
};

export const Telefono = ({ handleChange, values, errors, errorMessages }) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.telefono}
        className={classes.formControlCustom}
        style={{ marginTop: mobile ? "1rem" : "-15px" }}
      >
        <TextField
          id="filled-required"
          label="Teléfono fijo"
          variant="filled"
          name="telefono"
          value={values.telefono}
          className={classes.inputCustom}
          onChange={handleChange}
          error={errors.telefono}
          helperText={errorMessages.telefono}
          onInput={(e) => {
            let newLetter = e.target.value.substring(e.target.value.length - 1);
            if (isNaN(newLetter)) {
              let newValue = e.target.value.slice(0, -1);
              e.target.value = newValue;
            } else {
              e.target.value = e.target.value.slice(0, 8);
            }
          }}
        />
        <p className={classes.textoDescriptivo}>
          *Todos los campos son obligatorios, excepto el teléfono fijo.
        </p>
      </FormControl>
    </Grid>
  );
};
